import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import OneColumnB from '../components/OneColumnB/OneColumnB';
import { Link } from 'react-router-dom';

const Programs = () => {
    return (
        <div>
            <Navbar />
            <div className="section__padding app__background-gy">
                <div className="app__content">
                    <h1 className="headtext__roboto">Programs</h1>
                </div>
                <div className="app__background-gy">
                    <OneColumnB
                        subtitle="Recreational"
                        subheader="5 - 14 yrs"
                       paragraph="The Recreational league is designed for players who love the 
        spirit of the game but prefer a more relaxed and less competitive environment 
        compared to a competitive team. Our main focus in the recreational league is to 
        provide an enjoyable and organized experience where players can have fun while also 
        learning the game. We prioritize creating a positive and friendly atmosphere for all participants."
                    />
                </div>
                <div className="app__background-gy" style={{ paddingTop: '1rem', paddingBottom: '3rem' }}>
                    <button style={{ backgroundColor: 'var(--color-red)' }} className="app__button" type="button" > <Link to="/recreation"> Recreation</Link>  </button>
                </div>
                <div className="app__background-gy">
                    <OneColumnB
                        subtitle="Competitive"
                        subheader="U9 - U14 yrs"
                        paragraph="Our program is designed to prepare you for success in high school soccer and beyond. 
                By participating in our program, you'll gain the confidence, discipline, and teamwork skills necessary 
                to thrive in competitive soccer. Whether your goal is to make the varsity team, earn a college scholarship, 
                or pursue a professional career, our program will equip you with the skills and opportunities to achieve your aspirations. "

                    />
                </div>
                <div className="app__background-gy" style={{ paddingTop: '1rem' }}>
                    <button className="app__button" type="button"> <Link to="/competitive"> Competitive</Link> </button>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Programs